import { INTEGRATIONS } from './integrations'
import { PLATFORMS_NAMES } from './platforms'
import { TEAM } from './team'
import { TECH_NAMES } from './technologies'
import { ProjectId } from './types'

export const PROJECTS_DATA = [
  {
    projectId: ProjectId.Upwealth,
    name: 'Upwealth',
    team: [
      TEAM.VOLODYMYR_KATANSKYI,
      TEAM.KATERYNA_POLISHKO,
      TEAM.DMITRII_ALYMOV,
      TEAM.GEORGE_VIAZEMSKY,
      TEAM.IVAN_KLYMENKO,
      TEAM.PAVEL_KHUDYSHKIN,
      TEAM.SERGEY_BORDIUHOV,
      TEAM.PAVLO_VOLOVYCH,
      TEAM.KYRYLO_PAPAIANI,
    ],
    feedbacksId: ['feedbackUpWealth'],
    platformsNames: [PLATFORMS_NAMES.WEB],
    technologiesNames: [
      TECH_NAMES.NODE_JS,
      TECH_NAMES.REACT,
      TECH_NAMES.APOLLO,
      TECH_NAMES.STOREON,
      TECH_NAMES.KOA,
      TECH_NAMES.SEQUELIZE,
      TECH_NAMES.BULL_MQ,
      TECH_NAMES.JEST,
      TECH_NAMES.SEND_GRID,
      TECH_NAMES.WEB3,
      TECH_NAMES.METAMASK,
      TECH_NAMES.ALCHEMY,
      TECH_NAMES.PLAID,
      TECH_NAMES.WORKLAIR_SUPPORT_WIDGET,
    ],
    isHidden: true,
  },
  {
    projectId: ProjectId.Morpheus,
    name: 'Morpheus',
    team: [
      TEAM.VOLODYMYR_KATANSKYI,
      TEAM.GEORGE_VIAZEMSKY,
      TEAM.IVAN_KLYMENKO,
      TEAM.LINA_ALEKSANDROVA,
      TEAM.EKATERINA_NAUMCHIK,
    ],
    feedbacksId: ['feedbackMorpheus'],
    platformsNames: [PLATFORMS_NAMES.WEB],
    technologiesNames: [
      TECH_NAMES.REACT,
      TECH_NAMES.NODE_JS,
      TECH_NAMES.APOLLO,
    ],
  },

  {
    projectId: ProjectId.Sentr3,
    name: 'Sentr3',
    team: [
      TEAM.VOLODYMYR_KATANSKYI,
      TEAM.GEORGE_VIAZEMSKY,
      TEAM.DMITRII_ALYMOV,
      TEAM.EVGENII_DOLGOPOLOV,
      TEAM.KATE_OSYAGINA,
    ],
    feedbacksId: ['feedbackSentr3'],
    platformsNames: [
      PLATFORMS_NAMES.WEB,
      PLATFORMS_NAMES.IOS,
      PLATFORMS_NAMES.GOOGLE_PLAY,
    ],
    technologiesNames: [
      TECH_NAMES.NODE_JS,
      TECH_NAMES.REACT,
      TECH_NAMES.APOLLO,
      TECH_NAMES.STOREON,
      TECH_NAMES.KOA,
      TECH_NAMES.SEQUELIZE,
      TECH_NAMES.BULL_MQ,
      TECH_NAMES.JEST,
      TECH_NAMES.SEND_GRID,
      TECH_NAMES.WEB3,
      TECH_NAMES.TELEGRAM,
      TECH_NAMES.METAMASK,
      TECH_NAMES.ALCHEMY,
    ],
    integrations: [
      {
        title: 'Infrastructure',
        items: [
          INTEGRATIONS.ALCHEMY,
          INTEGRATIONS.UNLOCK,
          INTEGRATIONS.STRIPE,
          INTEGRATIONS.SHOPIFY,
        ],
      },
      {
        title: 'Wallet support',
        items: [
          INTEGRATIONS.LEDGER,
          INTEGRATIONS.COINBASE,
          INTEGRATIONS.WALLET_CONNECT,
          INTEGRATIONS.METAMASK,
          INTEGRATIONS.TREZOR,
          INTEGRATIONS.TRUST_WALLET,
          INTEGRATIONS.RAINBOW,
          INTEGRATIONS.ARGENT,
        ],
      },
      {
        title: 'Multi-chain token-gating',
        items: [
          INTEGRATIONS.ETHEREUM,
          INTEGRATIONS.POLYGON,
          INTEGRATIONS.BINANCE,
          INTEGRATIONS.INFINITY,
        ],
      },
    ],
  },

  {
    projectId: ProjectId.FallsPay,
    name: 'FallsPay',
    feedbacksId: ['50678103'],
    technologiesNames: [
      TECH_NAMES.REACT,
      TECH_NAMES.REACT_NATIVE,
      TECH_NAMES.NODE_JS,
      TECH_NAMES.REDUX,
      TECH_NAMES.JSON_API,
      TECH_NAMES.AMAZON_S3,
      TECH_NAMES.AMAZON_RDS,
      TECH_NAMES.AMAZON_EC2,
      TECH_NAMES.REDUX_SAGA,
      TECH_NAMES.REDIS,
    ],
    team: [
      TEAM.VOLODYMYR_KATANSKYI,
      TEAM.DMITRII_ALYMOV,
      TEAM.KATE_OSYAGINA,
      TEAM.YURIY_GORGOLYUK,
      TEAM.SERGEY_BORD,
    ],
    platformsNames: [
      PLATFORMS_NAMES.WEB,
      PLATFORMS_NAMES.IOS,
      PLATFORMS_NAMES.GOOGLE_PLAY,
    ],
  },

  {
    projectId: ProjectId.OhanaLink,
    name: 'OhanaLink Technologies',
    feedbacksId: ['24219005'],
    technologiesNames: [
      TECH_NAMES.REACT,
      TECH_NAMES.APOLLO,
      TECH_NAMES.REDUX,
      TECH_NAMES.REDUX_SAGA,
      TECH_NAMES.JSON_API,
      TECH_NAMES.RUBY,
      TECH_NAMES.RUBY_ON_RAILS,
      TECH_NAMES.SIDEKIQ,
      TECH_NAMES.POSTGRE_SQL,
      TECH_NAMES.DOCKER,
    ],
    platformsNames: [
      PLATFORMS_NAMES.APP_STORE,
      PLATFORMS_NAMES.GOOGLE_PLAY,
      PLATFORMS_NAMES.WEB,
    ],
    team: [
      TEAM.ANASTASIYA_KONOVALENKOVA,
      TEAM.ARTEM_TUTOV,
      TEAM.CHRISTINE_MATVIIENKO,
      TEAM.DANIIL_KAIBULAIEV,
      TEAM.GEORGE_VIAZEMSKY,
      TEAM.KIRILL_MASHARA,
      TEAM.MAX_RUDKO,
      TEAM.OLGA_ILIUK,
      TEAM.PANG,
      TEAM.PAVEL_KHUDYSHKIN,
      TEAM.SERGEY_BORD,
      TEAM.SERGEY_LAPTEV,
      TEAM.VADIM_SHALAMOV,
      TEAM.VOLODYMYR_KATANSKYI,
      TEAM.WANG,
      TEAM.YURII_SHULICHENKO,
    ],
  },

  {
    projectId: ProjectId.WhaleRoom,
    name: 'WhaleRoom',
    feedbacksId: ['56158746'],
    technologiesNames: [
      TECH_NAMES.REACT,
      TECH_NAMES.APOLLO,
      TECH_NAMES.SEQUELIZE,
      TECH_NAMES.SEND_GRID,
      TECH_NAMES.METAMASK,
      TECH_NAMES.KOA,
      TECH_NAMES.STOREON,
      TECH_NAMES.BULL_MQ,
      TECH_NAMES.JEST,
      TECH_NAMES.WEB3,
      TECH_NAMES.TELEGRAM,
      TECH_NAMES.ALCHEMY,
    ],
    platformsNames: [PLATFORMS_NAMES.WEB, PLATFORMS_NAMES.GOOGLE_PLAY],
    team: [
      TEAM.GEORGE_VIAZEMSKY,
      TEAM.DMITRII_ALYMOV,
      TEAM.ANDREW_KIRIIA,
      TEAM.VADIM_SHALAMOV,
      TEAM.KATE_OSYAGINA,
      TEAM.OLGA_KUZNETSOVA,
      TEAM.ANDRII_IZVARIN,
      TEAM.GIORGI_BIBILASHVILI,
      TEAM.EVGENII_DOLGOPOLOV,
      TEAM.ANATOLII_ZINCHENKO,
    ],
  },

  {
    projectId: ProjectId.BFast,
    name: 'BFast',
    feedbacksId: ['50678103'],
    technologiesNames: [
      TECH_NAMES.REACT,
      TECH_NAMES.REACT_NATIVE,
      TECH_NAMES.NODE_JS,
      TECH_NAMES.REDUX,
      TECH_NAMES.JSON_API,
      TECH_NAMES.AMAZON_S3,
      TECH_NAMES.AMAZON_RDS,
      TECH_NAMES.AMAZON_EC2,
      TECH_NAMES.REDUX_SAGA,
      TECH_NAMES.REDIS,
    ],
    platformsNames: [
      PLATFORMS_NAMES.WEB,
      PLATFORMS_NAMES.IOS,
      PLATFORMS_NAMES.GOOGLE_PLAY,
    ],
    team: [
      TEAM.SERGEY_BORD,
      TEAM.SERGEY_LAPTEV,
      TEAM.ANDREW_KIRIIA,
      TEAM.KATE_OSYAGINA,
      TEAM.MYROSLAV_DORYKEVYCH,
      TEAM.DMITRII_ALYMOV,
      TEAM.YURIY_GORGOLYUK,
      TEAM.GEORGE_VIAZEMSKY,
    ],
  },

  {
    projectId: ProjectId.WorkAxle,
    name: 'WorkAxle',
    feedbacksId: ['22626851'],
    technologiesNames: [
      TECH_NAMES.REACT,
      TECH_NAMES.RUBY_ON_RAILS,
      TECH_NAMES.PHOENIX,
      TECH_NAMES.POST_GIS,
      TECH_NAMES.AMAZON_EC2,
      TECH_NAMES.RUBY,
      TECH_NAMES.JSON_API,
      TECH_NAMES.POSTGRE_SQL,
      TECH_NAMES.REDUX,
      TECH_NAMES.NODE_JS,
      TECH_NAMES.REDIS,
      TECH_NAMES.ELIXIR,
    ],
    platformsNames: [
      PLATFORMS_NAMES.WEB,
      PLATFORMS_NAMES.APP_STORE,
      PLATFORMS_NAMES.GOOGLE_PLAY,
    ],
    team: [
      TEAM.ALEXEY_NEMEROVETS,
      TEAM.ANASTASIYA_KONOVALENKOVA,
      TEAM.ANDREW_LOS,
      TEAM.DENIS_KOMOGORCEV,
      TEAM.DMITRY_BROSHKOV,
      TEAM.DMYTRO_KOVAL,
      TEAM.GEORGE_VIAZEMSKY,
      TEAM.KIRILL_MASHARA,
      TEAM.LYUDA_DZIUBYNSKA,
      TEAM.MAX_RUDKO,
      TEAM.MEDET_TLEUKABILULY,
      TEAM.MISHA_YURCHENKOV,
      TEAM.OLGA_ILIUK,
      TEAM.OLHA_IIEVLIEVA,
      TEAM.PAVEL_KHUDYSHKIN,
      TEAM.SEMYON_PUPKOV,
      TEAM.SERGEY_KLUBAN,
      TEAM.SERGEY_LAPTEV,
      TEAM.SERGII_KOROTENKO,
      TEAM.VADIM_SHALAMOV,
    ],
  },

  {
    projectId: ProjectId.NetworkOS,
    name: 'NetworkOS',
    feedbacksId: ['24855519'],
    technologiesNames: [
      TECH_NAMES.REACT,
      TECH_NAMES.NODE_JS,
      TECH_NAMES.GRAPH_QL,
      TECH_NAMES.POSTGRE_SQL,
      TECH_NAMES.REDIS,
      TECH_NAMES.SOLIDITY,
      TECH_NAMES.APOLLO,
    ],
    platformsNames: [PLATFORMS_NAMES.WEB],
    team: [
      TEAM.ANASTASIYA_KONOVALENKOVA,
      TEAM.CHRISTINE_MATVIIENKO,
      TEAM.DANIIL_KAIBULAIEV,
      TEAM.GEORGE_VIAZEMSKY,
      TEAM.KIRILL_MASHARA,
      TEAM.MAX_RUDKO,
      TEAM.MYKHAIL_KAZIUTA,
      TEAM.SERGEY_BORD,
      TEAM.SERGEY_KLUBAN,
      TEAM.VADIM_SHALAMOV,
      TEAM.VIKTOR_OLEKS,
      TEAM.VLAD_ZARUDENSKY,
      TEAM.VOLODYMYR_KATANSKYI,
      TEAM.YURII_SHULICHENKO,
    ],
  },

  {
    projectId: ProjectId.Synchronos,
    name: 'Synchronos',
    feedbacksId: [],
    technologiesNames: [
      TECH_NAMES.WEB,
      TECH_NAMES.REACT_NATIVE,
      TECH_NAMES.IOS,
      TECH_NAMES.ANDROID,
      TECH_NAMES.NODE_JS,
    ],
    platformsNames: [],
    team: [
      TEAM.GEORGE_VIAZEMSKY,
      TEAM.SERGEY_LAPTEV,
      TEAM.KIRILL_MASHARA,
      TEAM.ANDREW_KIRIIA,
      TEAM.MAX_RUDKO,
      TEAM.VADIM_SHALAMOV,
      TEAM.VIKTOR_OLEKS,
    ],
  },

  {
    projectId: ProjectId.BitFinance,
    name: 'BitFinance',
    feedbacksId: ['24286099'],
    technologiesNames: [
      TECH_NAMES.AWS,
      TECH_NAMES.JSON_API,
      TECH_NAMES.POSTGRE_SQL,
      TECH_NAMES.RAILS,
      TECH_NAMES.REACT,
      TECH_NAMES.REDUX,
      TECH_NAMES.RUBY,
    ],
    // platformsNames: [PLATFORMS_NAMES.WEB],
    team: [
      TEAM.VOLODYMYR_KATANSKYI,
      TEAM.GEORGE_VIAZEMSKY,
      TEAM.VADIM_SHALAMOV,
      TEAM.VIKTOR_OLEKS,
      TEAM.ANASTASIYA_KONOVALENKOVA,
      TEAM.MAX_RUDKO,
      TEAM.SERGEY_KLUBAN,
    ],
  },

  {
    projectId: ProjectId.LbRMgR,
    name: 'LbR MgR',
    feedbacksId: ['24288936'],
    technologiesNames: [
      TECH_NAMES.REACT,
      TECH_NAMES.REACT_NATIVE,
      TECH_NAMES.REDUX,
      TECH_NAMES.REDUX_SAGA,
      TECH_NAMES.JSON_API,
      TECH_NAMES.RUBY,
      TECH_NAMES.RUBY_ON_RAILS,
      TECH_NAMES.SIDEKIQ,
      TECH_NAMES.POSTGRE_SQL,
      TECH_NAMES.DOCKER,
    ],
    platformsNames: [
      PLATFORMS_NAMES.APP_STORE,
      PLATFORMS_NAMES.GOOGLE_PLAY,
      PLATFORMS_NAMES.WEB,
    ],
    team: [
      TEAM.ALEXANDR_KORSAK,
      TEAM.ANASTASIYA_KONOVALENKOVA,
      TEAM.CHRISTINE_MATVIIENKO,
      TEAM.GEORGE_VIAZEMSKY,
      TEAM.MYKHAIL_KAZIUTA,
      TEAM.NIKITA_VYLEGZHANIN,
      TEAM.OLGA_ILIUK,
      TEAM.PAVEL_KHUDYSHKIN,
      TEAM.SERHIY_KOCHKIN,
      TEAM.SERGEY_KLUBAN,
      TEAM.SERGEY_LAPTEV,
      TEAM.TIGRAN_SAHYAKYAN,
      TEAM.VADIM_SHALAMOV,
      TEAM.VIKTOR_OLEKS,
      TEAM.VLAD_ZARUDENSKY,
      TEAM.VOLODYMYR_KATANSKYI,
      TEAM.WANG,
    ],
  },

  {
    projectId: ProjectId.Creator,
    name: 'Creator',
    feedbacksId: ['24288703'],
    technologiesNames: [
      TECH_NAMES.REACT,
      TECH_NAMES.REDUX,
      TECH_NAMES.JSON_API,
      TECH_NAMES.METAMASK,
      TECH_NAMES.PUSHER_JS,
      TECH_NAMES.RUBY,
      TECH_NAMES.RUBY_ON_RAILS,
      TECH_NAMES.POSTGRE_SQL,
      TECH_NAMES.REDIS,
    ],
    platformsNames: [PLATFORMS_NAMES.WEB],
    team: [
      TEAM.DENIS_KOMOGORCEV,
      TEAM.GEORGE_VIAZEMSKY,
      TEAM.MARAT_BEKTIMIROV,
      TEAM.NORBERT,
      TEAM.VADIM_SHALAMOV,
      TEAM.VITALY_AKULOV,
    ],
  },

  {
    projectId: ProjectId.FantasyInsiders,
    name: 'FantasyInsiders',
    feedbacksId: ['24288601'],
    technologiesNames: [
      TECH_NAMES.NODE_JS,
      TECH_NAMES.REACT,
      TECH_NAMES.APOLLO,
      TECH_NAMES.GRAPH_QL,
      TECH_NAMES.SEQUELIZE,
      TECH_NAMES.POSTGRE_SQL,
      TECH_NAMES.REDUX,
      TECH_NAMES.WEBPACK,
    ],
    platformsNames: [PLATFORMS_NAMES.WEB],
    team: [
      TEAM.ANTON_VALOV,
      TEAM.DENIS_KOMOGORCEV,
      TEAM.GEORGE_VIAZEMSKY,
      TEAM.LYUDA_DZIUBYNSKA,
      TEAM.SERGEY_KLUBAN,
      TEAM.SVYATOSLAV_DARDALAN,
      TEAM.VADIM_SHALAMOV,
      TEAM.VAZGEN_VARDEVANYAN,
      TEAM.VOLODYMYR_KATANSKYI,
    ],
  },

  {
    projectId: ProjectId.Voicereel,
    name: 'Voicereel',
    feedbacksId: ['24288492'],
    technologiesNames: [
      TECH_NAMES.EMBER_JS,
      TECH_NAMES.RUBY,
      TECH_NAMES.RAILS,
      TECH_NAMES.JSON_API,
      TECH_NAMES.REDIS,
      TECH_NAMES.SIDEKIQ,
      TECH_NAMES.POSTGRE_SQL,
    ],
    platformsNames: [],
    team: [
      TEAM.ANASTASIYA_KONOVALENKOVA,
      TEAM.ARTEM_GURZHII,
      TEAM.HAKOB_POGHOSYAN,
      TEAM.OLGA_ILIUK,
      TEAM.OLHA_IIEVLIEVA,
      TEAM.PAVEL_KHUDYSHKIN,
      TEAM.SEMYON_PUPKOV,
      TEAM.SVYATOSLAV_DARDALAN,
      TEAM.VADIM_SHALAMOV,
      TEAM.VAZGEN_VARDEVANYAN,
      TEAM.VOLODYMYR_KATANSKYI,
    ],
  },

  {
    projectId: ProjectId.Lyfta,
    name: 'Lyfta',
    feedbacksId: ['24288330'],
    technologiesNames: [
      TECH_NAMES.REACT,
      TECH_NAMES.REDUX,
      TECH_NAMES.REDUX_SAGA,
      TECH_NAMES.JSON_API,
      TECH_NAMES.RUBY,
      TECH_NAMES.RUBY_ON_RAILS,
      TECH_NAMES.POSTGRE_SQL,
      TECH_NAMES.SEQUELIZE,
      TECH_NAMES.HTML,
      TECH_NAMES.CSS,
      TECH_NAMES.UNITY,
    ],
    platformsNames: [PLATFORMS_NAMES.WEB],
    team: [
      TEAM.ANTON_VALOV,
      TEAM.KIRILL_MASHARA,
      TEAM.SERGEY_KUCHER,
      TEAM.SVYATOSLAV_DARDALAN,
      TEAM.VADIM_SHALAMOV,
      TEAM.YURI_YUZVOVICH,
    ],
  },

  {
    projectId: ProjectId.Tazawaj,
    name: 'Tazawaj',
    feedbacksId: ['24317186'],
    technologiesNames: [
      TECH_NAMES.REACT,
      TECH_NAMES.REACT_NATIVE,
      TECH_NAMES.REDUX,
      TECH_NAMES.REDUX_SAGA,
      TECH_NAMES.JSON_API,
      TECH_NAMES.RUBY,
      TECH_NAMES.RUBY_ON_RAILS,
      TECH_NAMES.SIDEKIQ,
      TECH_NAMES.POSTGRE_SQL,
      TECH_NAMES.DOCKER,
    ],
    platformsNames: [
      PLATFORMS_NAMES.APP_STORE,
      PLATFORMS_NAMES.GOOGLE_PLAY,
      PLATFORMS_NAMES.WEB,
    ],
    team: [
      TEAM.ANASTASIYA_KONOVALENKOVA,
      TEAM.OLHA_IIEVLIEVA,
      TEAM.PAVEL_KHUDYSHKIN,
      TEAM.SERGEY_KLUBAN,
      TEAM.SERGEY_LAPTEV,
      TEAM.TIGRAN_SAHYAKYAN,
      TEAM.VADIM_SHALAMOV,
      TEAM.VOLODYMYR_KATANSKYI,
    ],
  },

  {
    projectId: ProjectId.Guided,
    name: 'Guided',
    feedbacksId: ['24317184'],
    technologiesNames: [
      TECH_NAMES.AWS,
      TECH_NAMES.AUTH0,
      TECH_NAMES.DRAFT_JS,
      TECH_NAMES.JSON_API,
      TECH_NAMES.POSTGRE_SQL,
      TECH_NAMES.PUSHER_JS,
      TECH_NAMES.RUBY_ON_RAILS,
      TECH_NAMES.REACT,
      TECH_NAMES.REDUX,
      TECH_NAMES.RUBY,
    ],
    platformsNames: [PLATFORMS_NAMES.WEB],
    team: [
      TEAM.DENIS_KOMOGORCEV,
      TEAM.DMYTRO_KOVAL,
      TEAM.GEORGE_VIAZEMSKY,
      TEAM.LYUDA_DZIUBYNSKA,
      TEAM.MAX_RUDKO,
      TEAM.MISHA_YURCHENKOV,
      TEAM.OLHA_IIEVLIEVA,
      TEAM.SERGEY_KLUBAN,
      TEAM.SERGII_KOROTENKO,
      TEAM.VADIM_SHALAMOV,
    ],
  },

  {
    projectId: ProjectId.OvrPass,
    name: 'OvrPass',
    feedbacksId: ['24289035'],
    technologiesNames: [TECH_NAMES.REACT],
    platformsNames: [PLATFORMS_NAMES.WEB],
    team: [
      TEAM.ANASTASIYA_KONOVALENKOVA,
      TEAM.CHRISTINE_MATVIIENKO,
      TEAM.GEORGE_VIAZEMSKY,
      TEAM.SERGEY_BORD,
      TEAM.TIGRAN_SAHYAKYAN,
      TEAM.VLAD_ZARUDENSKY,
      TEAM.VOLODYMYR_KATANSKYI,
    ],
  },

  {
    projectId: ProjectId.DMI,
    name: 'DMI',
    feedbacksId: [],
    technologiesNames: [
      TECH_NAMES.REACT,
      TECH_NAMES.REACT_NATIVE,
      TECH_NAMES.REDUX,
      TECH_NAMES.REDUX_SAGA,
      TECH_NAMES.JSON_API,
      TECH_NAMES.AMAZON_EC2,
      TECH_NAMES.AMAZON_RDS,
      TECH_NAMES.AMAZON_S3,
      TECH_NAMES.NODE_JS,
    ],
    platformsNames: [PLATFORMS_NAMES.WEB],
    team: [
      TEAM.SERGEY_LAPTEV,
      TEAM.GEORGE_VIAZEMSKY,
      TEAM.ANDREW_KIRIIA,
      TEAM.YURIY_GORGOLYUK,
      TEAM.SEMYON_PUPKOV,
      TEAM.PAVEL_KHUDYSHKIN,
      TEAM.EVGENII_DOLGOPOLOV,
      TEAM.DAVID_ARUTIUNIAN,
      TEAM.MYROSLAV_DORYKEVYCH,
    ],
  },

  {
    projectId: ProjectId.SappChat,
    name: 'SappChat',
    feedbacksId: [],
    technologiesNames: [
      TECH_NAMES.NODE_JS,
      TECH_NAMES.REACT,
      TECH_NAMES.REACT_NATIVE,
      TECH_NAMES.SOLIDITY,
      TECH_NAMES.TRUST_WALLET,
      TECH_NAMES.APOLLO,
      TECH_NAMES.SEQUELIZE,
      TECH_NAMES.METAMASK,
      TECH_NAMES.STOREON,
      TECH_NAMES.BULL_MQ,
      TECH_NAMES.WEB3,
    ],
    platformsNames: [PLATFORMS_NAMES.WEB],
    team: [
      TEAM.GEORGE_VIAZEMSKY,
      TEAM.DMITRII_ALYMOV,
      TEAM.SERGEY_LAPTEV,
      TEAM.VADIM_SHALAMOV,
      TEAM.SIARHEI_SUKACH,
      TEAM.DAVID_ARUTIUNIAN,
    ],
  },
  {
    projectId: ProjectId.FuturWise,
    name: 'FuturWise',
    feedbacksId: ['futur-wise-feedback'],
    technologiesNames: [
      TECH_NAMES.REACT_NATIVE,
      TECH_NAMES.REACT,
      TECH_NAMES.NODE_JS,
      TECH_NAMES.APOLLO,
    ],
    platformsNames: [
      PLATFORMS_NAMES.WEB,
      PLATFORMS_NAMES.ANDROID,
      PLATFORMS_NAMES.IOS,
    ],
    team: [
      TEAM.GEORGE_VIAZEMSKY,
      TEAM.PAVLO_DZIUBAK,
      TEAM.ROMAN_GOREGLYAD,
      TEAM.DANIL_SOKOLOVSKY,
      TEAM.KATE_OSYAGINA,
    ],
  },
  {
    projectId: ProjectId.EmajinGolf,
    name: 'EmajinGolf app',
    feedbacksId: ['emajin-golf-feedback'],
    technologiesNames: [
      TECH_NAMES.REACT_NATIVE,
      TECH_NAMES.REACT,
      TECH_NAMES.NODE_JS,
      TECH_NAMES.APOLLO,
    ],
    platformsNames: [PLATFORMS_NAMES.ANDROID, PLATFORMS_NAMES.IOS],
    team: [
      TEAM.DMITRII_ALYMOV,
      TEAM.GEORGE_VIAZEMSKY,
      TEAM.SERGEY_LAPTEV,
      TEAM.PAVLO_DZIUBAK,
      TEAM.ROMAN_GOREGLYAD,
      TEAM.KATE_OSYAGINA,
      TEAM.HANNA_KATANSKA,
      TEAM.KYRYLO_PAPAIANI,
    ],
  },
]
